import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ForgotPasswordComponent } from './forgot-password.component';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        ForgotPasswordComponent
    ],
    imports     : [

        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressBarModule,

        FuseSharedModule,
		RouterModule,
		TranslateModule.forChild()
    ]
})
export class ForgotPasswordModule{}
